import React from 'react';
import { View,Image, Text } from './Primitives'
import { StyleSheet } from '@react-pdf/renderer'
import dayjs from 'dayjs'
import {usePdfType} from "./Hooks/PdfTypeContext";
// Create styles
const styles = StyleSheet.create({

    image: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 'auto',
        width: '100%'
    },

    pageNumber: {
        bottom: 10,
        left: 0,
        fontSize: 8,
        marginLeft: 5,
    },
    footer: {
        position: 'absolute',
        fontSize: 0,
        bottom: 0,
        left: 0,
        right: 0,
        textAlign: 'center',
        

    },
    flexContainer: {
        position: 'absolute',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        top: 50,
        left: 14,
    },

});

const Footer = ({charter,newPdfType}) => {
    const pdfType= usePdfType();

    newPdfType=pdfType?pdfType:newPdfType;

    const qg = newPdfType === 'Itinerary' ? 'Standard' : newPdfType === 'ItineraryQGov' ? 'QGov' : (charter?.qGov?'BidHistory/QGov':"BidHistory");
    const date = dayjs().format('DD/MMM/YYYY');
    return <View fixed style={styles.footer}>
        <Image style={styles.image} src={'/img/pdf/' + qg+'/Footer.jpg'}/>
        <View style={styles.flexContainer}>
            <Text fixed style={styles.pageNumber}
                  render={({pageNumber, totalPages}) => 'Page ' + pageNumber + ' of ' + totalPages}/>
            <Text style={styles.pageNumber}>Date {date}</Text>
            {charter?.requestId ? <Text style={styles.pageNumber}>Charter request: JB{charter.requestId}</Text> : null}
        </View>
    </View>
}



export default  Footer;